import React, { useEffect, useState } from "react";
import styles from "./Navbar.module.css";
import { FiMenu, FiX } from "react-icons/fi";
import { Link } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import { ChevronDown, ChevronUp, LogInIcon, User } from "lucide-react"; // Lucide icons
import { FaSignInAlt, FaUserCircle } from "react-icons/fa";

const Navbar = ({ userExists }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [opacity, setOpacity] = useState(1); // Start with opacity 0
  const [display, setDisplay] = useState("block");
  useEffect(() => {
    // Fade out effect on scroll
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const fadeStart = 300;
      const fadeEnd = 900;
      const newOpacity = Math.max(
        1 - (scrollY - fadeStart) / (fadeEnd - fadeStart),
        0
      );
      if (scrollY >= 900) setDisplay("none");
      else setDisplay("block");
      setOpacity(newOpacity);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleProductClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <header className={styles.navbar} style={{ display, opacity }}>
      <div className={styles.navbarContainer}>
        <div className={styles.logo}>
          <Link to={"/"}>
            <img src="/assets/logo.png" alt="Logo" />
          </Link>
        </div>

        <nav className={`${styles.navLinks} ${isOpen ? styles.showMenu : ""}`}>
          <Link to={"/#team"}>OUR TEAM</Link>
          <Link to={"/careers"}>CAREERS</Link>

          {/* Products Dropdown */}
          <div className={styles.dropdownContainer}>
            <button className={styles.dropdownBtn} onClick={handleProductClick}>
              PRODUCTS{" "}
              {anchorEl ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              MenuListProps={{
                sx: { backgroundColor: "black", color: "#fff" },
              }}
              PaperProps={{
                sx: {
                  borderRadius: "10px",
                  boxShadow: "0px 4px 12px rgba(255, 255, 255, 0.1)",
                  maxWidth: "200px",
                  textWrap: "wrap",
                },
              }}
            >
              <MenuItem
                onClick={handleClose}
                component={Link}
                to={"/product1"}
                sx={{
                  "&:hover": {
                    background: "#ffffff55",
                  },
                }}
              >
                Automatic Wheel Profile <br /> Measurement System
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={Link}
                to={"/product2"}
                sx={{
                  "&:hover": {
                    background: "#ffffff55",
                  },
                }}
              >
                Hot Box Detector
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={Link}
                to={"/product3"}
                sx={{
                  "&:hover": {
                    background: "#ffffff55",
                  },
                }}
              >
                Machine Vision
                <br /> Inspection System for <br />
                Rolling Stock (MVIS)
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={Link}
                to={"/product4"}
                sx={{
                  "&:hover": {
                    background: "#ffffff55",
                  },
                }}
              >
                Coach Condition <br />
                Monitoring System
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={Link}
                to={"/product5"}
                sx={{
                  "&:hover": {
                    background: "#ffffff55",
                  },
                }}
              >
                Autonomous Aerial <br />
                Inspection Platform
              </MenuItem>
            </Menu>
          </div>

          <Link to="/contact">CONTACT</Link>
          {!userExists ? (
            <Link to={"/login"}>
              <FaSignInAlt size={18} />
            </Link>
          ) : (
            <Link to={"/dashboard"}>
              <FaUserCircle size={18} />
            </Link>
          )}
        </nav>

        {/* Mobile Menu Icon */}
        <div className={styles.menuIcon} onClick={toggleMenu}>
          {isOpen ? <FiX /> : <FiMenu />}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
